/* unplugin-vue-components disabled */import { render } from "./pointicon.vue?vue&type=template&id=e1083790&scoped=true"
import script from "./pointicon.vue?vue&type=script&lang=js"
export * from "./pointicon.vue?vue&type=script&lang=js"

import "./pointicon.vue?vue&type=style&index=0&id=e1083790&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1083790"]])

export default __exports__